import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { AllProductLines } from 'self-service-api/constants/ProductLines';
import styled from 'styled-components';
import UITile from 'UIComponents/tile/UITile';
import { GYPSUM, OLAF } from 'HubStyleTokens/colors';
import ProductLineTile from './ProductLineTile';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { borderStyle } from '../FreeToolsSharedComponents';
import { SectionTitle } from '../../common/SharedComponents';
const WhyGoHubSpotContainer = styled(UITile).withConfig({
  displayName: "WhyGoHubSpotSection__WhyGoHubSpotContainer",
  componentId: "swcu30-0"
})(["background-color:", ";border:none;padding:20px 0 60px;margin:20px 0;"], GYPSUM);
const TitleSection = styled.div.withConfig({
  displayName: "WhyGoHubSpotSection__TitleSection",
  componentId: "swcu30-1"
})(["max-width:850px;margin:20px auto;text-align:center;"]);
const ProductLineTilesContainer = styled.div.withConfig({
  displayName: "WhyGoHubSpotSection__ProductLineTilesContainer",
  componentId: "swcu30-2"
})(["display:grid;grid-template-columns:repeat( ", ",calc(100% / ", ") );justify-items:center;max-width:1200px;margin:auto;"], AllProductLines.length, AllProductLines.length);

const WhyGoHubSpotSection = ({
  selectedNavItem,
  containerStyles
}) => {
  const productLineTileComponents = AllProductLines.map((productLine, index) => {
    const commonStyles = {
      gridColumnStart: index + 1,
      maxWidth: 225,
      borderRight: borderStyle,
      borderLeft: borderStyle,
      backgroundColor: OLAF,
      width: '100%',
      textAlign: 'center',
      padding: '15px'
    };
    return /*#__PURE__*/_jsx(ProductLineTile, {
      commonStyles: commonStyles,
      productLine: productLine
    }, productLine);
  });
  return /*#__PURE__*/_jsxs(WhyGoHubSpotContainer, {
    style: containerStyles,
    children: [/*#__PURE__*/_jsxs(TitleSection, {
      children: [/*#__PURE__*/_jsx(SectionTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `whyGoHubSpot.${selectedNavItem}.title`
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `whyGoHubSpot.${selectedNavItem}.subtitle`
        })
      })]
    }), /*#__PURE__*/_jsx(ProductLineTilesContainer, {
      children: productLineTileComponents
    })]
  });
};

export default WhyGoHubSpotSection;